const module = {
  config: {
    name: 'pengaturan',
    icon: 'ri-settings-4-line',
    desc: 'Digunakan untuk mendaftarkan, menonaktifkan, dan mengatur hak akses pengguna dan master data di Whistleblowing SEKAR',
    layout: true
  },
  routes: [
    { name: 'users', label: 'Daftar Pengguna', icon: null, path: '/users', component: () => import('./users.vue') },
    { name: 'allegation-categories', label: 'Kategori Aduan', icon: null, path: '/allegation-categories', component: () => import('./allegation-categories.vue') }
    // { name: 'role', icon: null, path: '/role', component: () => import('./role.vue') },
    // { name: 'permissions', icon: null, path: '/permissions', component: () => import('./permissions.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/config/_index.js